import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Upload, FileSpreadsheet, Users, LogOut, Wallet, Store, UserCog } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const ADMIN_NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/upload", label: "Upload Report", icon: Upload },
  { to: "/admin/reports", label: "Reports", icon: FileSpreadsheet },
  { to: "/admin/agents", label: "Agents", icon: Users },
  { to: "/admin/merchants", label: "Merchants", icon: Store },
  { to: "/admin/account", label: "Account", icon: UserCog },
];
const AGENT_NAV = [{ to: "/portal", label: "My Residuals", icon: Wallet, end: true }, { to: "/portal/account", label: "Account", icon: UserCog }];

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const items = user.role === "admin" ? ADMIN_NAV : AGENT_NAV;
  return (
    <div className="min-h-screen flex bg-[#0B0F17]">
      <aside className="w-60 shrink-0 border-r border-slate-800 bg-[#0d1320] hidden md:flex flex-col">
        <div className="px-6 py-6 border-b border-slate-800">
          <div className="font-display text-lg font-semibold tracking-tight">Residual<span className="text-emerald-400">Ledger</span></div>
          <div className="text-[11px] font-mono uppercase tracking-wider text-slate-500 mt-1">{user.role} console</div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {items.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} data-testid={`nav-${label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${isActive ? "bg-blue-500/10 text-blue-300 border border-blue-500/20" : "text-slate-400 hover:text-slate-100 hover:bg-slate-800/60 border border-transparent"}`}>
              <Icon size={16} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-slate-800">
          <div className="text-sm text-slate-200 truncate" data-testid="current-user-name">{user.name}</div>
          <div className="text-xs text-slate-500 truncate font-mono">{user.email}</div>
          <button data-testid="logout-button" onClick={() => { logout(); nav("/login"); }}
            className="mt-3 flex items-center gap-2 text-xs text-slate-400 hover:text-rose-400 transition-colors">
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </aside>
      <div className="flex-1 min-w-0">
        <div className="md:hidden flex items-center justify-between px-4 py-3 border-b border-slate-800 sticky top-0 z-40 backdrop-blur-md bg-slate-950/80">
          <div className="font-display font-semibold">Residual<span className="text-emerald-400">Ledger</span></div>
          <div className="flex gap-3">
            {items.map(({ to, icon: Icon }) => <NavLink key={to} to={to} end className="text-slate-400"><Icon size={18} /></NavLink>)}
            <button onClick={() => { logout(); nav("/login"); }} className="text-slate-400"><LogOut size={18} /></button>
          </div>
        </div>
        <main className="p-5 sm:p-8 lg:p-10 max-w-[1800px]">{children}</main>
      </div>
    </div>
  );
}
